import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ImageElement } from "..";

function AuthDesign({
  isReset = false,
  welcomeHeading,
  heading,
  headingClass = "",
  children,
  signup = false,
}) {
  return (
    <section className={`authPage ${headingClass}`}>
      <Row className="h-100 g-0">
        <Col
          lg={4}
          className="d-flex align-items-center justify-content-center justify-content-lg-end"
        >
          <Link className="authPage_logo" to="/">
            <ImageElement source="logo.svg" className="img-fluid" alt="logo" />
          </Link>
          {signup ? (
            <>{children}</>
          ) : (
            <div className="authPage_wrap">
              <h1 className="fw-semibold">
                {welcomeHeading}
                <br className="d-none d-lg-block" /> {heading}
              </h1>
              {children}
            </div>
          )}
        </Col>
        <Col className={`${!isReset === "d-none d-lg-block"}`}>
          <div className="gallery">
            <div className="gallery_inner">
              <div className="gallery_list">
                <ImageElement source="thumb-img01.webp" alt="thumb01" />
                <ImageElement source="thumb-img02.webp" alt="thumb02" />
                <ImageElement source="thumb-img03.webp" alt="thumb03" />
                <ImageElement source="thumb-img01.webp" alt="thumb04" />
                <ImageElement source="thumb-img07.webp" alt="thumb05" />
                <ImageElement source="thumb-img02.webp" alt="thumb06" />
                <ImageElement source="thumb-img03.webp" alt="thumb07" />
                <ImageElement source="thumb-img01.webp" alt="thumb08" />
                {isReset && (
                  <>
                    <ImageElement source="thumb-img01.webp" alt="thumb01" />
                    <ImageElement source="thumb-img02.webp" alt="thumb02" />
                    <ImageElement source="thumb-img03.webp" alt="thumb03" />
                    <ImageElement source="thumb-img01.webp" alt="thumb01" />
                  </>
                )}
              </div>
              <div className="gallery_list">
                <ImageElement source="thumb-img04.webp" alt="thumb09" />
                <ImageElement source="thumb-img05.webp" alt="thumb10" />
                <ImageElement source="thumb-img06.webp" alt="thumb11" />
                <ImageElement source="thumb-img07.webp" alt="thumb12" />
                <ImageElement source="thumb-img04.webp" alt="thumb13" />
                <ImageElement source="thumb-img05.webp" alt="thumb14" />
                <ImageElement source="thumb-img06.webp" alt="thumb15" />
                <ImageElement source="thumb-img07.webp" alt="thumb16" />
                {isReset && (
                  <>
                    <ImageElement source="thumb-img04.webp" alt="thumb04" />
                    <ImageElement source="thumb-img05.webp" alt="thumb06" />
                    <ImageElement source="thumb-img06.webp" alt="thumb07" />
                    <ImageElement source="thumb-img07.webp" alt="thumb08" />
                  </>
                )}
              </div>
              <div className="gallery_list">
                <ImageElement source="thumb-img07.webp" alt="thumb17" />
                <ImageElement source="thumb-img08.webp" alt="thumb18" />
                <ImageElement source="thumb-img09.webp" alt="thumb19" />
                <ImageElement source="thumb-img10.webp" alt="thumb20" />
                <ImageElement source="thumb-img07.webp" alt="thumb21" />
                <ImageElement source="thumb-img08.webp" alt="thumb22" />
                <ImageElement source="thumb-img09.webp" alt="thumb23" />
                <ImageElement source="thumb-img10.webp" alt="thumb24" />
                {isReset && (
                  <>
                    <ImageElement source="thumb-img07.webp" alt="thumb09" />
                    <ImageElement source="thumb-img08.webp" alt="thumb10" />
                    <ImageElement source="thumb-img09.webp" alt="thumb03" />
                    <ImageElement source="thumb-img10.webp" alt="thumb04" />
                  </>
                )}
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </section>
  );
}

export default AuthDesign;
